<div class="no-offers-tile">
    <div class="no-offers-tile__header">
        {{ header | translate }}
    </div>

    <div class="no-offers-tile__content">
        <div *ngIf="title"
             class="no-offers-tile__content__title">
            {{ title | translate }}
        </div>
        <div class="no-offers-tile__content__description">
            {{ description | translate }}
        </div>
        <div class="no-offers-tile__content__buttons">
            <button class="btn btn--secondary btn--small-padding"
                    (click)="onActionButtonClick()">
                {{ actionButtonLabel | translate}}
            </button>
            <button class="btn btn--secondary-inverted btn--small-padding"
                    (click)="clearFilters()">
                {{ getTranslationKey('clearFilters') | translate}}
            </button>
        </div>
    </div>
</div>
